import { useState } from 'react';

import { EventsQuery } from '../../apollo/__generated__/graphql';
import { useEventsQuery } from '../../event/hooks/useEventsQuery';
import { useDeleteEventMutation } from '../hooks/useDeleteEventMutation';
import { useUpdateEventMutation } from '../hooks/useUpdateEventMutation';

export const useAdminEvents = () => {
  const [isCreateDrawerOpen, setIsCreateDrawerOpen] = useState<boolean>(false);
  const [editingEvent, setEditingEvent] = useState<
    EventsQuery['events'][number] | null
  >(null);
  const [eventToDeleteId, setEventToDeleteId] = useState<string | null>(null);
  const [milestonesEventId, setMilestonesEventId] = useState<string | null>(
    null,
  );
  const [vouchersEventId, setVouchersEventId] = useState<string | null>(null);

  const onShowDeleteDialog = (eventId: string) => {
    setEventToDeleteId(eventId);
  };
  const onCloseDeleteDialog = () => {
    setEventToDeleteId(null);
  };

  const { data: eventsData, loading } = useEventsQuery();
  const { deleteEvent } = useDeleteEventMutation(onCloseDeleteDialog);
  const { updateEvent } = useUpdateEventMutation();

  const onChangeArePaymentsEnabled = (
    eventId: string,
    arePaymentsEnabled: boolean,
  ) => {
    updateEvent({ eventId, arePaymentsEnabled });
  };

  const onChangeAreBedroomPaymentsEnabled = (
    eventId: string,
    areBedroomPaymentsEnabled: boolean,
  ) => {
    updateEvent({ eventId, areBedroomPaymentsEnabled });
  };

  const onChangeIsTargetEnabled = (
    eventId: string,
    isTargetEnabled: boolean,
  ) => {
    updateEvent({
      eventId,
      isTargetEnabled,
    });
  };

  const onChangeIsTinderEnabled = (
    eventId: string,
    isTinderEnabled: boolean,
  ) => {
    updateEvent({
      eventId,
      isTinderEnabled,
    });
  };

  const onCreate = () => {
    setIsCreateDrawerOpen(true);
  };

  const onCloseCreateDrawer = (createdEventId?: string) => {
    setIsCreateDrawerOpen(false);
    if (createdEventId) {
      setMilestonesEventId(createdEventId);
    }
  };

  const events = eventsData?.events ?? [];

  const onShowMilestones = (eventId: string) => {
    setMilestonesEventId(eventId);
  };

  const onShowVouchers = (eventId: string) => {
    setVouchersEventId(eventId);
  };

  const onCloseMilestonesDrawer = () => {
    setMilestonesEventId(null);
  };

  const onCloseVouchersDrawer = () => {
    setVouchersEventId(null);
  };

  const onEditEvent = (event: EventsQuery['events'][number]) => {
    setEditingEvent(event);
  };

  const onCloseEditEvent = () => {
    setEditingEvent(null);
  };

  const onDeleteEvent = () => {
    if (eventToDeleteId) {
      deleteEvent(eventToDeleteId);
    }
  };

  return {
    events,
    loading,
    onCreate,
    isCreateDrawerOpen,
    onCloseCreateDrawer,
    milestonesEventId,
    vouchersEventId,
    onShowMilestones,
    onShowVouchers,
    onCloseMilestonesDrawer,
    onCloseVouchersDrawer,
    onEditEvent,
    editingEvent,
    onCloseEditEvent,
    onShowDeleteDialog,
    onDeleteEvent,
    eventToDeleteId,
    onCloseDeleteDialog,
    onChangeArePaymentsEnabled,
    onChangeIsTargetEnabled,
    onChangeIsTinderEnabled,
    onChangeAreBedroomPaymentsEnabled,
  };
};
